<script setup lang="ts">
import { computed } from 'vue'
import { Button, InlineAlert, Progress } from 'catalyst-vue'
import { useCatalogStore } from '../../stores/catalog'
import { useControlSize } from '../../lib/library-layout'

/**
 * 雲端目錄遷移的進度與停止原因。
 *
 * 遷移失敗不阻擋書庫：這裡只是說明做到哪裡，書庫清單、封面與本地閱讀都照常可用。
 * 顯示的是「階段 + 已完成筆數 + 原因」，因為使用者要知道的正是做到哪裡就停了。
 */
const catalog = useCatalogStore()
const controlSize = useControlSize()

const percent = computed(() => catalog.total ? Math.round((catalog.completed / catalog.total) * 100) : 0)
const visible = computed(() => catalog.running || !!catalog.reason)
</script>

<template>
  <div v-if="visible" class="catalog-status">
    <template v-if="catalog.running">
      <p class="catalog-status-label" role="status" aria-live="polite">
        {{ catalog.stageLabel }}<span v-if="catalog.total">：{{ catalog.completed }}／{{ catalog.total }}</span>
      </p>
      <Progress v-if="catalog.total" :value="percent" :aria-label="catalog.stageLabel" />
    </template>
    <!-- InlineAlert 只有預設 slot，重試按鈕因此放在訊息之後，不用不存在的 actions slot。 -->
    <InlineAlert v-else tone="warning">
      <span>{{ catalog.stoppedSummary }}</span>
      <Button plain :size="controlSize" class="ml-2" @click="catalog.retry()">重試</Button>
    </InlineAlert>
  </div>
</template>

<style scoped>
.catalog-status { display: flex; flex-direction: column; gap: 0.5rem; margin-block: 1rem; }
.catalog-status-label { font-size: 0.875rem; }
</style>
